import defaultImpact from './config/securityImpactAssessment.json';

const loadSecurityRisks = () => {
  return defaultImpact;
};

export default loadSecurityRisks;
